<template>
	<div>
		<pt-form-item label="是否合格:" labelWidth="90px" :required="true">
        <el-radio-group v-model="form.result" name="result" v-validate="'required'" data-vv-as="是否合格">
					<el-radio label="QUALIFIED">合格</el-radio>
					<el-radio label="NOT_QUALIFIED_WAIT_FUTURE_ACTION">不合格</el-radio>
				</el-radio-group>
    </pt-form-item>
    <pt-form-item label="原因" labelWidth="90px" v-if="form.result == 'NOT_QUALIFIED_WAIT_FUTURE_ACTION'" :required="true">
      <not-qualified-reason name="reason" data-vv-as="原因" v-validate="'required'" v-model="form.reason" class="texta" :placeholder="form.result == 'QUALIFIED' ? '选填' : '请填写原因'"></not-qualified-reason>
    </pt-form-item>
    <pt-form-item label="DNA提取人:" labelWidth="90px" :required="true">
       <el-input name="operatorName.DNAExtractionOperator" data-vv-as="DNA提取人" v-validate="'required'" v-model="form.operatorName.DNAExtractionOperator" placeholder="请输入DNA提取人姓名"></el-input>
    </pt-form-item>
    <!-- <pt-form-item label="原因" labelWidth="90px" v-if="form.result == 'NOT_QUALIFIED_WAIT_FUTURE_ACTION'" :required="true">
        <el-input name="reason" data-vv-as="原因" v-validate="'required'" type="textarea" :autosize="{ minRows: 3, maxRows: 6 }" v-model="form.reason" class="texta" :placeholder="form.result == 'QUALIFIED' ? '选填' : '请填写原因'"></el-input>
    </pt-form-item> -->
	</div>
</template>

<script>
import { validate } from 'utils/validate'
import notQualifiedReason from 'cps/lab-order/process/form/components-with-data/not-qualified-reason'
import { next } from '../status.js'
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    detailIn: {
      type: Boolean,
      default: false
    },
    orderStatus: [Array]
  },
  components: {
    notQualifiedReason
  },
  data () {
    return {
      title: '核酸提取',
      form: {
        result: 'QUALIFIED',
        reason: '',
        operatorName: {
          DNAExtractionOperator: ''
        }
      },
      rules: {
        result: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        reason: [],
        expressNum: [{ required: true, message: '请填写快递单号', trigger: 'change' }]
      },
      pass: false,
      reasonObj: {
        have: false,
        reasons: []
      }
    }
  },
  watch: {
    form: {
      handler: function (val, oldVal) {
        if (val.result === 'SAMPLE_RECOLLECT') {
          this.$set(this.rules, 'reason', [{ required: true, message: '请填写原因', trigger: 'change' }])
          this.$delete(this.rules, 'expressNum')
        } else {
          this.$set(this.rules, 'expressNum', [{ required: true, message: '请填写快递单号', trigger: 'change' }])
          this.$delete(this.rules, 'reason')
        }
      },
      deep: true
    }
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    next () {
      let data = { orderIds: [this.order.id],
        action: this.status,
        operatorName: this.form.operatorName }
      if (this.form.result !== 'QUALIFIED') {
        data.orderStatusDetail = {
          orderStatusResult: this.form.result,
          reason: this.form.reason
        }
      } else {
        data.orderStatusDetail = {
          orderStatusResult: this.form.result
        }
      }
      return next.call(this, data)
    }
  },
  created () {

  }

}
</script>

<style lang="less">

</style>
